import { useAnalytics } from '@satellite/composables/useAnalytics';

import { useCheckoutFlow } from './useCheckoutFlow';
import { useWarehouseInfo } from './useWarehouseInfo';

export function useTrackJunoEvent() {
  const analytics = useAnalytics();
  const { warehouseData } = useWarehouseInfo();
  const { appointmentId, assetVisitId } = useCheckoutFlow();

  const trackJunoEvent = (event: string, payload?: Record<string, unknown>) => {
    analytics.track(event, {
      warehouse_id: warehouseData.value?.id,
      warehouse_name: warehouseData.value?.name,
      org_id: warehouseData.value?.org.id,
      org_name: warehouseData.value?.org.name,
      ...(appointmentId.value && { appointment_id: appointmentId.value }),
      ...(assetVisitId.value && { asset_visit_id: assetVisitId.value }),
      ...payload
    });
  };

  return { trackJunoEvent };
}
